import { ScrollTracking } from '../../tracking/ScrollTracking';
export const InViewTracking = ScrollTracking;
//# sourceMappingURL=InViewTracking.js.map